import React from 'react';
import { cn } from '@/lib/utils';
import './primitives.css';

/**
 * Neutral label chip. For severity use <SeverityBadge>, for workflow
 * status use <StatusBadge>; this one is for everything else (counts,
 * source names, tags, "Sample", "Beta").
 *
 *   tone:  'neutral' (default) | 'accent' | 'success' | 'warning' | 'danger' | 'info'
 *   size:  'md' (20px) | 'sm' (18px)
 *   plain: sentence case Inter instead of uppercase mono
 */
export default function Badge({
  tone = 'neutral',
  size = 'md',
  plain = false,
  icon: Icon,
  className,
  children,
  ...rest
}) {
  return (
    <span
      className={cn(
        'is-badge',
        `is-badge--${tone}`,
        size === 'sm' && 'is-badge--sm',
        plain && 'is-badge--plain',
        className
      )}
      {...rest}
    >
      {Icon && <Icon aria-hidden="true" />}
      {children}
    </span>
  );
}
